const EmailApiUrl = {
    ItineraryShareMail: "api/Email/ItineraryShareMail",
    CareerSendMail: "api/Email/CareerSendMail",
    SendAgentMail: "api/Email/SendAgentMail",
    EnquiryNowSendMail: "api/email/EnquiryNowSendMail",
    RequestCallBackSendMail: "api/email/RequestCallBackSendMail",
    SendEndUserMail: "api/Email/SendEndUserMail",

}
export default EmailApiUrl;